import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { queryFAQPage } from "@/strapiQuery/faq";
import { FAQPageContent } from "@/components/pages/faq/FAQ";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");

  const faqPageContentPromise = getStrapiEntity<FAQPageContent>(
    "faq",
    queryFAQPage
  );

  const [layout, faqPageContent] = await Promise.all([
    layoutPromise,
    faqPageContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      ...faqPageContent,
      intlMessages,
      defaultCanonicalRoute: routes.faq,
    },
    revalidate: 10,
  };
};

export { FAQ as default } from "@/components/pages/faq/FAQ";
